<div class="coder-debug" *requiredCredential="debugUser" [ngClass]="{ active: active }">
  <icon (click)="activateCoderDebugger()" type="bug" />
  <div class="content">
    <h3>Company Scopes</h3>
    @for (providerInstance of companyProviders; track providerInstance) {
      <div (click)="displayProvider(providerInstance)" style="cursor: help; display: flex;" title="Click for console log of provider">
        {{ providerInstance.lastUse | customDate: 'time' }} - {{ providerInstance.dataProvider.companyName || providerInstance.dataProvider.companyId }} - {{ providerInstance.activeContexts.length }} scopes
        @if (providerInstance.activeContexts.length == 0) {
          <div style="border: 2px solid #000000; border-radius: 5px; margin-left: 5px; padding: 0 5px; font-weight: bold;">
            <icon type="clock" small style="margin-right: 5px;" />{{ timeLeft.get(providerInstance) }}
          </div>
        }
      </div>
    }
    <h3>Hub messages (SignalR ConnState: {{ signalrConnectionState }})</h3>
    <div>
      @for (message of hubMessages; track message) {
        <div title="Click for console log of message" (click)="displayMessage(message.message)" style="cursor: help; display: flex;">{{ message.timestamp | customDate: 'fullTime' }} - {{ getMessageHeader(message.message) }}</div>
      }
    </div>
  </div>
</div>
